import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import validator from 'validator';
import { forgotPinCode } from '../../../../AxiosRtk/PinCode';
import { setTokenPinPartialLogin } from '../../../../AxiosRtk/Auth';
import Success from '../../../Common/Success';
import { useDispatch, useSelector } from 'react-redux';
import useLangTranslation from '../../../../../customHooks/languageProvider';
import { getAccessToken } from '../../../../../../utils/helper';
import useCrypto from '../../../../../customHooks/crypto';
import { getSession } from '../../../../../../utils/session';
import { getter } from '../../../../../../utils/storage';

const ForgetPinCode = () => {
    const dispatch = useDispatch();
    const { getLangTranslation } = useLangTranslation();
    const { decryptRequest } = useCrypto();
    const [email, setEmail] = useState({ value: '', error: '' });
    const { forgetPincodeTokenPartialLogin } = useSelector(({ auth }) => auth);
    function handleInputChange(e) {
        const { value } = e.target;
        if (validator.isEmail(value)) {
            setEmail({
                value,
                error: ''
            })
        } else {
            setEmail({
                value,
                error: 'EMAIL_FORMAT_NOT_VALID_ERR'
            })
        }
    }

    function handleSendClick() {
        if (isEmpty(email?.value)) {
            setEmail({
                ...email,
                error: 'SIGN_UP_EMAIL_IS_REQUIRED_ERR'
            })
            return;
        }
        const accessToken = getSession("kidoProtectUserAccessToken") ?? getter("kidoProtectUserAccessToken");
        forgotPinCode(email?.value, accessToken)
            .then((res) => {
                dispatch(setTokenPinPartialLogin(res?.data?.result[0]?.token));
            })
            .catch((error) => {
                console.log("forgot pincode catch error ==>>", error);
            })
    }

    if (forgetPincodeTokenPartialLogin) {
        return (
            <Success
                successMsg={getLangTranslation('PIN_CODE_RECOVERY_SUCCESS', 'An email was sent to your registered email address with your Pin Code')}
                redirectTo="/auth/enter-pin-code"
            />
        )
    } else {
        return (
            <div className="container">
                <div className="auth-wrapper">
                    <div className="auth-inner">
                        <h2 className="text-center mb-3 auth-sub-title">{getLangTranslation('FGT_PIN_ENTER_YOUR_EMAIL_ID', 'Enter your E-mail address')}</h2>
                        <p className="text-center mb-6 light-text">{getLangTranslation('FGT_PIN_PLS_ENTER_YOUR_EMAIL_ADDRESS', 'Please enter your registered email address')}</p>
                        <div className="mb-6">
                            <label htmlFor="email" className="form-label">{getLangTranslation('EMAIL', 'Email')}</label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                placeholder={getLangTranslation('EMAIL', 'Email')}
                                value={email?.value}
                                onChange={handleInputChange}
                            />
                            {email?.error && <label className='field-error'>{getLangTranslation(email?.error)}</label>}
                        </div>
                        <div className="d-grid">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSendClick}
                            >
                                <span className="btn-upper-case">{getLangTranslation('PIN_CODE_RECOVERY_SEND', 'SEND')}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}

export default ForgetPinCode;